import { render } from "./CustomColorPicker.vue?vue&type=template&id=30e9f396&scoped=true"
import script from "./CustomColorPicker.vue?vue&type=script&lang=ts"
export * from "./CustomColorPicker.vue?vue&type=script&lang=ts"

import "./CustomColorPicker.vue?vue&type=style&index=0&id=30e9f396&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-30e9f396"

export default script